export default "__VITE_ASSET__D_g4gLa3__"